<div class="dialog-container">
    <!-- Dialog Header -->
    <div class="dialog-header d-flex justify-content-between align-items-center mb-4">
        <h4 class="dialog-title mb-0">{{ isViewMode ? 'View Agenda Item' : (isEditMode ? 'Edit Agenda Item' : 'Create Agenda Item') }}</h4>
        <button type="button" class="close-btn" (click)="onCancel()" aria-label="Close dialog">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 5L5 15M5 5L15 15" stroke="#333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </button>
    </div>

    <!-- Dialog Content -->
    <form [formGroup]="agendaForm" (ngSubmit)="onSave()">
        <!-- Linked PR Section - Moved to Top -->
        <div class="form-section mb-4">
            <h5 class="section-title fw-bold mb-3">Linked PR</h5>
            
            <!-- Dropdown for create and edit modes, readonly input for view mode only -->
            <app-searchable-select
                *ngIf="!isViewMode"
                [options]="purchaseRequestOptions"
                [label]="''"
                [id]="'linkedPR'"
                [placeholder]="'Search or select PR...'"
                [inputClass]="'form-control rounded-4 bg-light p-2'"
                formControlName="prIdentifiers"
                (selectionChange)="onPRSelectionChange($event)">
            </app-searchable-select>
            
            <input
                *ngIf="isViewMode"
                type="text" 
                id="linkedPR" 
                class="form-control rounded-4 bg-light p-2" 
                formControlName="prIdentifiers"
                placeholder="Enter PR number"
                readonly
                [disabled]="true">
        </div>

        <!-- Basic Information Section -->
        <div class="form-section mb-4">
            <h5 class="section-title fw-bold mb-3">Basic Information</h5>
            
            <!-- Agenda Title (Arabic) -->
            <div class="mb-3">
                <label for="agendaTitleAR" class="form-label fw-bold">Agenda Title (Arabic) <span style="color: red;">*</span></label>
                <input 
                    type="text" 
                    id="agendaTitleAR" 
                    class="form-control" 
                    formControlName="agendaTitleAR"
                    placeholder="Enter agenda title in Arabic"
                    [readonly]="isViewMode"
                    [disabled]="isViewMode">
            </div>

            <!-- Agenda Title (English) -->
            <div class="mb-3">
                <label for="agendaTitleEN" class="form-label fw-bold">Agenda Title (English) <span style="color: red;">*</span></label>
                <input 
                    type="text" 
                    id="agendaTitleEN" 
                    class="form-control" 
                    formControlName="agendaTitleEN"
                    placeholder="Enter agenda title in English"
                    [readonly]="isViewMode"
                    [disabled]="isViewMode">
            </div>

            <!-- Subject -->
            <div class="mb-3">
                <label for="subject" class="form-label fw-bold">Subject <span style="color: red;">*</span></label>
                <input 
                    type="text" 
                    id="subject" 
                    class="form-control" 
                    formControlName="subject"
                    placeholder="Enter subject"
                    [readonly]="isViewMode"
                    [disabled]="isViewMode">
            </div>

            <!-- Department -->
            <div class="mb-3">
                <label for="department" class="form-label fw-bold">Department</label>
                <select 
                    id="department" 
                    class="form-control" 
                    formControlName="department"
                    [disabled]="isViewMode">
                    <option value="">Select Department</option>
                    <option *ngFor="let dept of departments" [value]="dept">{{ dept }}</option>
                </select>
            </div>

            <!-- Current Stage -->
            <div class="mb-3">
                <label for="currentStage" class="form-label fw-bold">Current Stage</label>
                <select 
                    id="currentStage" 
                    class="form-control" 
                    formControlName="currentStage"
                    [disabled]="isViewMode">
                    <option value="">Select Stage</option>
                    <option *ngFor="let stage of currentStages" [value]="stage">{{ stage }}</option>
                </select>
            </div>

            <!-- Agenda Description (English) -->
            <div class="mb-3">
                <label for="agendaDescriptionEN" class="form-label fw-bold">Agenda Description (English)</label>
                <textarea 
                    id="agendaDescriptionEN" 
                    class="form-control" 
                    formControlName="agendaDescriptionEN"
                    rows="4"
                    placeholder="Enter agenda description in English"
                    [readonly]="isViewMode"
                    [disabled]="isViewMode"></textarea>
            </div>

            <!-- Agenda Description (Arabic) -->
            <div class="mb-3">
                <label for="agendaDescriptionAR" class="form-label fw-bold">Agenda Description (Arabic)</label>
                <textarea 
                    id="agendaDescriptionAR" 
                    class="form-control" 
                    formControlName="agendaDescriptionAR"
                    rows="4"
                    placeholder="Enter agenda description in Arabic"
                    [readonly]="isViewMode"
                    [disabled]="isViewMode"></textarea>
            </div>

            <!-- Required From TC -->
            <div class="mb-3">
                <label for="requiredFromTC" class="form-label fw-bold">Required From TC</label>
                <textarea 
                    id="requiredFromTC" 
                    class="form-control" 
                    formControlName="requiredFromTC"
                    rows="3"
                    placeholder="Enter requirements"
                    [readonly]="isViewMode"
                    [disabled]="isViewMode"></textarea>
            </div>

            <!-- TC Notes -->
            <div class="mb-3">
                <label for="tcNotes" class="form-label fw-bold">TC Notes</label>
                <textarea 
                    id="tcNotes" 
                    class="form-control"  
                    formControlName="tcNotes"
                    rows="3"
                    placeholder="Enter TC notes"
                    [readonly]="isViewMode"
                    [disabled]="isViewMode"></textarea>
            </div>
        </div>

        <!-- TC Decision Section -->
        <div class="form-section mb-4">
            <h5 class="section-title fw-bold mb-3">TC Decision</h5>
            
            <!-- TC Decision (English) -->
            <div class="mb-3">
                <label for="tcDecisionEN" class="form-label fw-bold">TC Decision (English)</label>
                <div class="rich-text-editor" [class.readonly]="isViewMode">
                    <div class="editor-toolbar" [ariaDisabled]>
                        <button type="button" class="toolbar-btn" (click)="executeEditorCommand(tcDecisionEnEditor, 'tcDecisionEN', 'bold')" aria-label="Bold">
                            <i class="fas fa-bold"></i>
                        </button>
                        <button type="button" class="toolbar-btn" (click)="executeEditorCommand(tcDecisionEnEditor, 'tcDecisionEN', 'italic')" aria-label="Italic">
                            <i class="fas fa-italic"></i>
                        </button>
                        <button type="button" class="toolbar-btn" (click)="executeEditorCommand(tcDecisionEnEditor, 'tcDecisionEN', 'underline')" aria-label="Underline">
                            <i class="fas fa-underline"></i>
                        </button>
                        <button type="button" class="toolbar-btn" (click)="executeEditorCommand(tcDecisionEnEditor, 'tcDecisionEN', 'insertOrderedList')" aria-label="Numbered List">
                            <i class="fas fa-list-ol"></i>
                        </button>
                        <button type="button" class="toolbar-btn" (click)="executeEditorCommand(tcDecisionEnEditor, 'tcDecisionEN', 'insertUnorderedList')" aria-label="Bullet List">
                            <i class="fas fa-list-ul"></i>
                        </button>
                        <label class="toolbar-btn toolbar-color-btn" aria-label="Text Color" title="Text Color">
                            <i class="fas fa-font"></i>
                            <span class="color-underline"></span>
                            <input type="color" value="#532E60" (input)="executeEditorCommand(tcDecisionEnEditor, 'tcDecisionEN', 'foreColor', $any($event.target).value)">
                        </label>
                        <button type="button" class="toolbar-btn toolbar-highlight-btn" (click)="executeEditorCommand(tcDecisionEnEditor, 'tcDecisionEN', 'hiliteColor', '#FFF3B0')" aria-label="Highlight" title="Highlight">
                            <span class="highlight-icon">A</span>
                            <span class="highlight-preview"></span>
                        </button>
                        <button type="button" class="toolbar-btn" (click)="executeEditorCommand(tcDecisionEnEditor, 'tcDecisionEN', 'removeFormat')" aria-label="Clear Formatting" title="Clear Formatting">
                            <span class="clear-format-icon">Tx</span>
                        </button>
                    </div>
                    <div
                        #tcDecisionEnEditor
                        id="tcDecisionEN"
                        class="editor-surface"
                        [attr.contenteditable]="!isViewMode"
                        [attr.data-placeholder]="'Enter TC decision in English'"
                        [class.is-empty]="isEditorEmpty('tcDecisionEN')"
                        (input)="onEditorInput('tcDecisionEN', tcDecisionEnEditor)"
                        (paste)="onEditorPaste($event, 'tcDecisionEN', tcDecisionEnEditor)"
                        (blur)="onEditorBlur('tcDecisionEN')"></div>
                </div>
                <div class="mt-2" *ngIf="!isViewMode">
                    <button 
                        type="button" 
                        class="btn btn-sm translate-btn"
                        (click)="onTranslateToArabic()"
                        [disabled]="!hasEditorText('tcDecisionEN') || isTranslating">
                        <span *ngIf="!isTranslating">Translate to Arabic</span>
                        <span *ngIf="isTranslating">Translating...</span>
                    </button>
                </div>
            </div>

            <!-- TC Decision (Arabic) -->
            <div class="mb-3">
                <label for="tcDecisionAR" class="form-label fw-bold">TC Decision (Arabic)</label>
                <div class="rich-text-editor arabic-editor" [class.readonly]="isViewMode">
                    <div class="editor-toolbar" [ariaDisabled]="!isViewMode">
                        <button type="button" class="toolbar-btn" (click)="executeEditorCommand(tcDecisionArEditor, 'tcDecisionAR', 'bold')" aria-label="Bold">
                            <i class="fas fa-bold"></i>
                        </button>
                        <button type="button" class="toolbar-btn" (click)="executeEditorCommand(tcDecisionArEditor, 'tcDecisionAR', 'italic')" aria-label="Italic">
                            <i class="fas fa-italic"></i>
                        </button>
                        <button type="button" class="toolbar-btn" (click)="executeEditorCommand(tcDecisionArEditor, 'tcDecisionAR', 'underline')" aria-label="Underline">
                            <i class="fas fa-underline"></i>
                        </button>
                        <button type="button" class="toolbar-btn" (click)="executeEditorCommand(tcDecisionArEditor, 'tcDecisionAR', 'insertOrderedList')" aria-label="Numbered List">
                            <i class="fas fa-list-ol"></i>
                        </button>
                        <button type="button" class="toolbar-btn" (click)="executeEditorCommand(tcDecisionArEditor, 'tcDecisionAR', 'insertUnorderedList')" aria-label="Bullet List">
                            <i class="fas fa-list-ul"></i>
                        </button>
                        <label class="toolbar-btn toolbar-color-btn" aria-label="Text Color" title="Text Color">
                            <i class="fas fa-font"></i>
                            <span class="color-underline"></span>
                            <input type="color" value="#532E60" (input)="executeEditorCommand(tcDecisionArEditor, 'tcDecisionAR', 'foreColor', $any($event.target).value)">
                        </label>
                        <button type="button" class="toolbar-btn toolbar-highlight-btn" (click)="executeEditorCommand(tcDecisionArEditor, 'tcDecisionAR', 'hiliteColor', '#FFF3B0')" aria-label="Highlight" title="Highlight">
                            <span class="highlight-icon">A</span>
                            <span class="highlight-preview"></span>
                        </button>
                        <button type="button" class="toolbar-btn" (click)="executeEditorCommand(tcDecisionArEditor, 'tcDecisionAR', 'removeFormat')" aria-label="Clear Formatting" title="Clear Formatting">
                            <span class="clear-format-icon">Tx</span>
                        </button>
                    </div>
                    <div
                        #tcDecisionArEditor
                        id="tcDecisionAR"
                        class="editor-surface"
                        [attr.contenteditable]="!isViewMode"
                        [attr.data-placeholder]="'Enter TC decision in Arabic (or it will be auto-filled from English)'"
                        [class.is-empty]="isEditorEmpty('tcDecisionAR')"
                        (input)="onEditorInput('tcDecisionAR', tcDecisionArEditor)"
                        (paste)="onEditorPaste($event, 'tcDecisionAR', tcDecisionArEditor)"
                        (blur)="onEditorBlur('tcDecisionAR')"></div>
                </div>
            </div>
        </div>

        <!-- Attachments Section -->
        <div class="form-section mb-4">
            <h5 class="section-title fw-bold mb-3">Attachments</h5>
            <app-file-upload
                #fileUploadComponent
                label="Attachments"
                placeholderText="Click or drag files here to upload (ToR, BOQ, Technical Specifications, etc.)"
                [multiple]="true"
                inputId="agenda-attachments-upload"
                [isRequired]="false"
                [formControl]="$any(agendaForm.get('attachments'))"
                [disabled]="isViewMode"
                [maxFiles]="10">
            </app-file-upload>
        </div>

        <!-- Dialog Footer -->
        <div class="dialog-footer d-flex justify-content-end gap-2">
            <button type="button" class="btn cancel-btn" (click)="onCancel()">{{ isViewMode ? 'Close' : 'Cancel' }}</button>
            <button *ngIf="!isViewMode" type="button" class="btn add-another-btn" (click)="onAddAnother()">Add Another</button>
            <button *ngIf="!isViewMode" type="submit" class="btn save-btn">Save</button>
        </div>
    </form>
</div>
